module.exports = __webpack_public_path__ + "img/Default-M-18.c99f9b19.svg";